'use strict';

import * as fitvids from 'fitvids';

const SELECTORS = '.js-fit-video, .content-panel';

export function init() {
    const elements = document.querySelectorAll(SELECTORS);

    if (elements.length === 0) {
        return false;
    }

    fitvids(SELECTORS);
}

export default { init }
